const ModalWrapper = ({ children }) => {
  return (
    <div className="modal" tabIndex={"-1"} role="dialog">
      <div className="modal-dialog" role="document">
        <div className="modal-content"style={{
            maxHeight: '95vh',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
          }}>{children}</div>
      </div>
    </div>
  );
};

export default ModalWrapper;
